export function isAdmin(user) {
  if (!user || !user.role) return false // בדיקה אם user או role ריקים
  return user.role === 'admin'
}

export function isAdminOrEditor(user) {
  if (!user || !user.role) return false // בדיקה אם user או role ריקים
  return user.role === 'admin' || user.role === 'editor'
}

export function isCommentOwnerOrPrivileged(user, comment) {
  if (!user || !comment) return false // טיפול במקרים בהם user או comment לא קיימים
  return user._id === comment.userId || ['admin', 'editor'].includes(user.role)
}
